import { cn } from "@babybjorn/ui";
import {
	useEffect,
	useRef,
	useState,
	type ButtonHTMLAttributes,
	type FC,
} from "react";
import Icon from "../../../components/general/Icon";
import * as s from "./SpecialButton.module.scss";

type SpecialButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	variant: "cart" | "search";
	label?: string;
	open?: boolean;
	itemCount?: number | null;
	pulseOnChangeAmount?: boolean;
};

const SpecialButton: FC<SpecialButtonProps> = ({
	variant,
	label,
	itemCount,
	open,
	pulseOnChangeAmount = true,
	...rest
}) => {
	const [pulse, setPulse] = useState(false);
	const oldItemCount = useRef(itemCount);

	if (itemCount !== oldItemCount.current) {
		setPulse(true);
	}
	oldItemCount.current = itemCount;

	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (pulse) {
			const timeoutId = setTimeout(() => setPulse(false), 150);
			return () => clearTimeout(timeoutId);
		}
	}, [pulse]);

	return (
		<button
			aria-label={label}
			className={cn(s.special, s[variant], { [s.open]: open })}
			{...rest}
		>
			<Icon icon={variant} width={variant === "search" ? 20 : 24} />

			{variant === "search" && label}

			{itemCount !== null && (
				<span
					className={cn(s.count, {
						[s.noItems]: !itemCount,
						[s.pulse]: pulseOnChangeAmount && pulse,
					})}
				>
					{itemCount}
				</span>
			)}
		</button>
	);
};

export default SpecialButton;
